<script setup lang="ts">
// merchant-pc 根组件 (PR-22a-3 stub, 单 router-view 占位)
</script>

<template>
  <router-view />
</template>
